import React from "react";
import { AppStateContext } from "../domain/state";

export const useAppReducer = () => React.useContext(AppStateContext);
